import { Trans } from "@lingui/react/macro";

const year = new Date().getFullYear();

export function RegrelloCopyright() {
  return <Trans context="copyright">©{year} Regrello Group</Trans>;
}
